export const wpClassNames = {
    WRAPPER: 'ql-ctabanner',
}

export const idAttribute = 'ql-cta-banner-breadcrumbs';
export const altLabel = 'representation of the image';